import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        kicker="读者口碑"
        title="追更读者怎么说"
        desc="来自追更党、漫画党与设定考据党读者的真实使用感受。"
      />
      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {testimonials.map((t) => (
          <figure
            key={t.name}
            className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6"
          >
            <div className="flex items-center gap-1 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm" />
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                {t.name.charAt(0)}
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-400">{t.tag}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}